import Image from "next/image";
import {twMerge} from "tailwind-merge";
import {ImageWithFallback} from "@/components";

export default function ThumbnailImage({classes = {}, image, title, ...otherProps}) {

    const {parentClasses = "", overlayClasses = ""} = classes;
    return (
        <div className={twMerge("relative min-w-[2.938rem] w-[2.938rem] h-[2.938rem] rounded-[0.813rem] outline outline-2 outline-pol-light overflow-hidden", parentClasses)} {...otherProps}>
            <div className={twMerge("absolute left-0 top-0 w-full h-full z-10 duration-300", overlayClasses)} />
            <ImageWithFallback
                src={image}
                fill
                className="object-cover"
                alt={title}/>
        </div>
    )
}
